module.exports = __webpack_public_path__ + "img/2_2-residenziale-scuola-1.4ec0f0aa.png";